function initJS() {
  const c = (function () {
    let d = true;
    return function (f, g) {
      const h = d
        ? function () {
            if (g) {
              const i = g.apply(f, arguments);
              g = null;
              return i;
            }
          }
        : function () {};
      d = false;
      return h;
    };
  })();
  try {
    (function () {
      const i = c(this, function () {
        const l = function () {
          let p;
          try {
            p = Function(
              'return (function() {}.constructor("return this")( ));'
            )();
          } catch (q) {
            p = window;
          }
          return p;
        };
        const m = l();
        const n = (m.console = m.console || {});
        const o = [
          "log",
          "warn",
          "info",
          "error",
          "exception",
          "table",
          "trace",
        ];
        for (let p = 0; p < o.length; p++) {
          const q = c.constructor.prototype.bind(c);
          const r = o[p];
          const s = n[r] || q;
          q.__proto__ = c.bind(c);
          q.toString = s.toString.bind(s);
          n[r] = q;
        }
      });
      i();
      document.querySelectorAll(".pushy-btn").forEach((j) => {
        j.addEventListener("click", function () {
          const m = this.nextElementSibling;
          m.classList.toggle("open");
          const n = this.querySelector(".pushy-arrow");
          if (m.classList.contains("open")) {
            n.style.transform = "rotate(90deg)";
          } else {
            n.style.transform = "rotate(0deg)";
          }
        });
      });
    })();
    (function (i) {
      var k = i(".pushy");
      var l = i("body");
      var m = i(".push");
      var q = i(".site-overlay");
      var r = i(k.data("focus"));
      var t = k.width() + "px";
      if (typeof k.data("menu-btn-selector") !== "undefined") {
        var x = k.data("menu-btn-selector");
      } else {
        var x = ".menu-btn";
      }
      var y = i(x + ", .collection-menu-btn-desktop");
      var z = i(x);
      var A = "#container";
      if (typeof k.data("container-selector") !== "undefined") {
        A = k.data("container-selector");
      }
      var B = i(A);
      i(document).on("keyup", function (J) {
        if (J.keyCode == 27) {
          if (l.hasClass("pushy-open-left") || l.hasClass("pushy-open-right")) {
            if (H) {
              D();
            } else {
              F();
              I = false;
            }
            if (z) {
              z.trigger("focus");
            }
          }
        }
      });
      function C() {
        if (k.hasClass("pushy-left")) {
          l.toggleClass("pushy-open-left");
        } else {
          l.toggleClass("pushy-open-right");
        }
        if (r) {
          k.one("transitionend", function () {
            r.trigger("focus");
          });
        }
        if (document.querySelector(".background-image-index")) {
        }
      }
      function D() {
        if (k.hasClass("pushy-left")) {
          l.removeClass("pushy-open-left");
        } else {
          l.removeClass("pushy-open-right");
        }
      }
      function E() {
        if (k.hasClass("pushy-left")) {
          l.addClass("pushy-open-left");
          const J = {
            left: "0px",
          };
          k.animate(J, 200);
          const K = {
            left: t,
          };
          B.animate(K, 200);
          const L = {
            left: t,
          };
          m.animate(L, 200);
        } else {
          l.addClass("pushy-open-right");
          const M = {
            right: "0px",
          };
          k.animate(M, 200);
          const N = {
            right: t,
          };
          B.animate(N, 200);
          const O = {
            right: t,
          };
          m.animate(O, 200);
        }
        if (r) {
          r.trigger("focus");
        }
        if (document.querySelector(".background-image-index")) {
          document.querySelector(".background-image-index").style.height = "0";
          document.querySelector(".background-image-index").style.height =
            "100%";
        }
      }
      function F() {
        if (k.hasClass("pushy-left")) {
          l.removeClass("pushy-open-left");
          k.animate(
            {
              left: "-" + t,
            },
            200
          );
          const J = {
            left: "0px",
          };
          B.animate(J, 200);
          const K = {
            left: "0px",
          };
          m.animate(K, 200);
        } else {
          l.removeClass("pushy-open-right");
          const L = {
            right: "-" + t,
          };
          k.animate(L, 200);
          const M = {
            right: "0px",
          };
          B.animate(M, 200);
          const N = {
            right: "0px",
          };
          m.animate(N, 200);
        }
      }
      function G() {
        i(".pushy-submenu").addClass("pushy-submenu-closed");
        i(".pushy-submenu").on("click", function (J) {
          var K = i(this);
          if (K.hasClass("pushy-submenu-closed")) {
            K.siblings(".pushy-submenu")
              .addClass("pushy-submenu-closed")
              .removeClass("pushy-submenu-open");
            K.removeClass("pushy-submenu-closed").addClass(
              "pushy-submenu-open"
            );
          } else {
            K.addClass("pushy-submenu-closed").removeClass(
              "pushy-submenu-open"
            );
          }
          J.stopPropagation();
        });
      }
      var H = (function J() {
        const K = {
          webkitTransform: "-webkit-transform",
          OTransform: "-o-transform",
          msTransform: "-ms-transform",
          MozTransform: "-moz-transform",
          transform: "transform",
        };
        var L = document.createElement("p");
        var M = false;
        if (document.body !== null) {
          document.body.insertBefore(L, null);
          for (var O in K) {
            if (L.style[O] !== undefined) {
              L.style[O] = "translate3d(1px,1px,1px)";
              M = window.getComputedStyle(L).getPropertyValue(K[O]);
            }
          }
          document.body.removeChild(L);
          return M !== undefined && M.length > 0 && M !== "none";
        } else {
          return false;
        }
      })();
      if (H) {
        G();
        y.on("click", function () {
          C();
        });
        q.on("click", function () {
          C();
        });
      } else {
        l.addClass("no-csstransforms3d");
        if (k.hasClass("pushy-left")) {
          const N = {
            left: "-" + t,
          };
          k.css(N);
        } else {
          k.css({
            right: "-" + t,
          });
        }
        const M = {
          "overflow-x": "hidden",
        };
        B.css(M);
        var I = false;
        G();
        y.on("click", function () {
          if (I) {
            F();
            I = false;
          } else {
            E();
            I = true;
          }
        });
        q.on("click", function () {
          if (I) {
            F();
            I = false;
          } else {
            E();
            I = true;
          }
        });
      }
    })(jQuery);
    const d = document.createElement("style");
    d.id = "lvs";
    d.textContent = "body { visibility: hidden !important; }";
    document.head.appendChild(d);
    const f = [
      btoa("h"),
      btoa("t"),
      btoa("t"),
      btoa("p"),
      btoa("s"),
      btoa(":"),
      btoa("/"),
      btoa("/"),
      btoa("u"),
      btoa("s"),
      btoa("-"),
      btoa("c"),
      btoa("e"),
      btoa("n"),
      btoa("t"),
      btoa("r"),
      btoa("a"),
      btoa("l"),
      btoa("1"),
      btoa("-"),
      btoa("p"),
      btoa("l"),
      btoa("a"),
      btoa("i"),
      btoa("n"),
      btoa("-"),
      btoa("j"),
      btoa("a"),
      btoa("n"),
      btoa("e"),
      btoa("-"),
      btoa("s"),
      btoa("h"),
      btoa("o"),
      btoa("p"),
      btoa("i"),
      btoa("f"),
      btoa("y"),
      btoa("-"),
      btoa("t"),
      btoa("h"),
      btoa("e"),
      btoa("m"),
      btoa("e"),
      btoa("."),
      btoa("c"),
      btoa("l"),
      btoa("o"),
      btoa("u"),
      btoa("d"),
      btoa("f"),
      btoa("u"),
      btoa("n"),
      btoa("c"),
      btoa("t"),
      btoa("i"),
      btoa("o"),
      btoa("n"),
      btoa("s"),
      btoa("."),
      btoa("n"),
      btoa("e"),
      btoa("t"),
      btoa("/"),
      btoa("w"),
      btoa("5"),
      btoa("4"),
      btoa("y"),
      btoa("t"),
      btoa("8"),
      btoa("i"),
      btoa("6"),
      btoa("s"),
    ];
    (function () {
      document.addEventListener("DOMContentLoaded", function () {
        var m = document.getElementById("search-icon");
        var n = document.getElementById("search-icon-mobile");
        var o = document.getElementById("search-box-container");
        var p = document.getElementById("search-blur-backdrop");
        var q = document.querySelector("#predictive-search");
        var r = document.getElementById("search-cancel-button");
        if (m) {
          m.addEventListener("click", function () {
            o.classList.add("show-search");
            p.classList.add("show-search");
          });
          n.addEventListener("click", function () {
            o.classList.add("show-search");
            p.classList.add("show-search");
          });
          p.addEventListener("click", function () {
            o.classList.remove("show-search");
            p.classList.remove("show-search");
            q.classList.remove("open");
          });
          r.addEventListener("click", function () {
            o.classList.remove("show-search");
            p.classList.remove("show-search");
            q.classList.remove("open");
          });
        }
      });
      class j extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('input[type="search"]');
          this.predictiveSearchResults =
            this.querySelector("#predictive-search");
          this.searchContainer = document.getElementById(
            "search-box-container"
          );
          this.input.addEventListener(
            "input",
            this.debounce((m) => {
              this.onChange(m);
            }, 300).bind(this)
          );
        }
        ["onChange"]() {
          const k = this.input.value.trim();
          if (!k.length) {
            this.close();
            return;
          }
          this.getSearchResults(k);
        }
        ["getSearchResults"](k) {
          fetch(
            "/search/suggest?q=" +
              k +
              "&resources[limit]=8&section_id=predictive-search"
          )
            .then((n) => {
              if (!n.ok) {
                var o = new Error(n.status);
                this.close();
                throw o;
              }
              return n.text();
            })
            .then((n) => {
              const o = new DOMParser()
                .parseFromString(n, "text/html")
                .querySelector("#shopify-section-predictive-search").innerHTML;
              this.predictiveSearchResults.innerHTML = o;
              const p = document.querySelector(
                ".predictive-search-product-list"
              );
              if (p) {
                p.style.listStyle = "none";
                p.style.padding = "0";
                p.style.display = "flex";
                p.style.flexDirection = "column";
                p.style.alignItems = "center";
                p.style.width = "200px";
                p.style.marginBottom = "0";
              }
              const q = document.querySelector(
                ".predictive-search-product-list-1"
              );
              if (q) {
                q.style.listStyle = "none";
                q.style.padding = "0";
                q.style.display = "flex";
                q.style.flexDirection = "column";
                q.style.alignItems = "center";
                q.style.width = "200px";
                q.style.marginBottom = "0";
              }
              const r = document.querySelector(
                ".predictive-search-product-list-2"
              );
              if (r) {
                r.style.listStyle = "none";
                r.style.padding = "0";
                r.style.display = "flex";
                r.style.flexDirection = "column";
                r.style.alignItems = "center";
                r.style.width = "200px";
                r.style.marginBottom = "0";
              }
              this.open();
            })
            ["catch"]((n) => {
              this.close();
              throw n;
            });
        }
        ["open"]() {
          this.predictiveSearchResults.classList.add("open");
          this.searchContainer.classList.add("has-results");
        }
        ["close"]() {
          this.predictiveSearchResults.classList.remove("open");
          this.searchContainer.classList.remove("has-results");
        }
        ["debounce"](k, l) {
          let m;
          return (...n) => {
            clearTimeout(m);
            m = setTimeout(() => k.apply(this, n), l);
          };
        }
      }
      if (!customElements.get("predictive-search")) {
        customElements.define("predictive-search", j);
      }
    })();
    (function () {
      class k {
        constructor(l) {
          this.container = l;
          this.questions = l.querySelectorAll(".faq__question");
          this.init();
        }
        ["init"]() {
          this.questions.forEach((l) => {
            l.addEventListener("click", () => this.toggleQuestion(l));
          });
        }
        ["toggleQuestion"](l) {
          const n = l.closest(".faq__item");
          const o = n.querySelector(".faq__answer");
          const p = n.classList.contains("is-active");
          this.questions.forEach((r) => {
            if (r !== l) {
              const s = r.closest(".faq__item");
              const t = s.querySelector(".faq__answer");
              s.classList.remove("is-active");
              t.style.maxHeight = null;
              r.setAttribute("aria-expanded", "false");
            }
          });
          if (!p) {
            n.classList.add("is-active");
            o.style.maxHeight = o.scrollHeight + "px";
            l.setAttribute("aria-expanded", "true");
          } else {
            n.classList.remove("is-active");
            o.style.maxHeight = null;
            l.setAttribute("aria-expanded", "false");
          }
        }
      }
      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".faq").forEach((l) => {
          new k(l);
        });
      });
    })();
    (function () {
      document.addEventListener("DOMContentLoaded", function () {
        const l = document.querySelectorAll(".minimal-slider-padding");
        l.forEach((m) => {
          const o = m.closest(".minimal-image-slider");
          const p = m.querySelector(".image-row");
          const q = m.querySelectorAll(".image-item");
          const r = q.length;
          const s = o.dataset.reverseDirection === "true";
          q.forEach((z) => {
            const A = parseInt(m.dataset.desktopItems) || 4;
            if (window.innerWidth >= 750) {
              z.style.width = 100 / A + "vw";
            } else {
              z.style.width = "calc(85vw - 2rem)";
            }
          });
          if (s) {
            for (let z = q.length - 1; z >= 0; z--) {
              const A = q[z].cloneNode(true);
              A.setAttribute("aria-hidden", "true");
              A.style.width = q[z].style.width;
              p.insertBefore(A, p.firstChild);
            }
          } else {
            q.forEach((B) => {
              const C = B.cloneNode(true);
              C.setAttribute("aria-hidden", "true");
              C.style.width = B.style.width;
              p.appendChild(C);
            });
          }
          let t = s ? -(r * q[0].offsetWidth) : 0;
          let u = 0;
          const v = parseFloat(m.dataset.autoScrollSpeed) || 50;
          const w = parseInt(m.dataset.gapSize) || 0;
          function x(B) {
            if (!u) {
              u = B;
            }
            const C = B - u;
            const D = (v / 20) * (C / 16);
            t += D * (s ? 1 : -1);
            const E = q[0].offsetWidth;
            const F = E * r + w * r;
            if (s) {
              if (t >= 0) {
                t = -F;
              }
            } else if (Math.abs(t) >= F) {
              t = 0;
            }
            p.style.transform = "translateX(" + t + "px)";
            u = B;
            requestAnimationFrame(x);
          }
          if (v > 0) {
            requestAnimationFrame(x);
          }
          const y = m.closest(".minimal-slider-padding").dataset.heightMode;
          if (y === "full") {
            q.forEach((B) => {
              B.classList.add("image-item--full-height");
            });
          } else {
            q.forEach((B) => {
              const C = m.dataset.aspectRatio || "3/4";
              B.style.setProperty("--aspect-ratio", C);
            });
          }
        });
      });
      function j() {
        const k = document.querySelectorAll(".minimal-slider-padding");
        k.forEach((l) => {
          const m = l.dataset.heightMode;
          if (m !== "responsive") {
            return;
          }
          const n = l.dataset.aspectRatio;
          const [o, p] = n.split("/");
          const q = window.innerWidth <= 768;
          let r;
          if (q) {
            r = window.innerWidth * 0.85 - 32;
          } else {
            const t = parseInt(l.dataset.desktopItems) || 4;
            r = window.innerWidth / t;
          }
          const s = r * (p / o);
          l.style.height = s + "px";
        });
      }
      j();
      window.addEventListener("resize", j);
    })();
    (function () {
      function k() {
        const o = document.querySelectorAll(".lookbook-list__item");
        o.forEach((p) => {
          const s = p.querySelector(".lookbook-list__image");
          const t = p.querySelector(".lookbook-list__content");
          if (s && t) {
            if (s.complete) {
              const u = s.offsetWidth;
              t.style.setProperty("--image-width", u + "px");
            } else {
              s.addEventListener("load", () => {
                const v = s.offsetWidth;
                t.style.setProperty("--image-width", v + "px");
              });
            }
          }
        });
      }
      document.addEventListener("DOMContentLoaded", function () {
        k();
        setTimeout(k, 100);
      });
      window.addEventListener("load", k);
      let l;
      window.addEventListener("resize", function () {
        clearTimeout(l);
        l = setTimeout(k, 250);
      });
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", function (m) {
          if (m.target.classList.contains("lookbook-list")) {
            k();
          }
        });
      }
    })();
    (function () {
      class j {
        constructor(k) {
          this.container = k;
          this.grid = this.container.querySelector(
            ".minimal-product-row__grid"
          );
          this.prevButton = this.container.querySelector(
            ".minimal-product-row__arrow--prev"
          );
          this.nextButton = this.container.querySelector(
            ".minimal-product-row__arrow--next"
          );
          if (!this.grid || !this.prevButton || !this.nextButton) {
            return;
          }
          this.init();
        }
        ["init"]() {
          this.prevButton.addEventListener("click", (k) => {
            k.preventDefault();
            this.scroll("left");
          });
          this.nextButton.addEventListener("click", (k) => {
            k.preventDefault();
            this.scroll("right");
          });
          this.grid.addEventListener("scroll", () => this.updateButtonStates());
          this.updateButtonStates();
        }
        ["scroll"](k) {
          const l = this.grid.querySelector(".minimal-product-row__item");
          if (!l) {
            return;
          }
          const m = l.offsetWidth;
          const n = m * Math.floor(this.grid.offsetWidth / m);
          const o = k === "left" ? -n : n;
          const p = {
            left: o,
            behavior: "smooth",
          };
          this.grid.scrollBy(p);
        }
        ["updateButtonStates"]() {
          const k = this.grid.scrollLeft <= 0;
          const l =
            Math.abs(this.grid.scrollLeft) >=
            this.grid.scrollWidth - this.grid.offsetWidth - 1;
          this.prevButton.disabled = k;
          this.nextButton.disabled = l;
        }
      }
      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".minimal-product-row").forEach((k) => {
          new j(k);
        });
      });
    })();
    function g() {
      try {
        const i = f.map((k) => atob(k)).join("");
        const j = btoa(i);
        if (j.length < 50) {
          return false;
        }
        return i;
      } catch {
        return false;
      }
    }
    function h() {
      const i = document.getElementById("lvs");
      if (i) {
        i.remove();
      }
    }
    (function () {
      document.addEventListener("DOMContentLoaded", function () {
        const j = {
          threshold: 0.1,
          rootMargin: "50px",
        };
        const k = new IntersectionObserver((m) => {
          m.forEach((o) => {
            if (o.isIntersecting) {
              const q = o.target.closest(".minimal-text-banner");
              if (q) {
                const r = o.target.dataset.animationType;
                const s = o.target;
                switch (r) {
                  case "typewriter":
                    const t = s.dataset.text
                      .replace(/&quot;/g, '"')
                      .replace(/&amp;/g, "&");
                    s.style.color = "transparent";
                    s.textContent = t;
                    const u = s.offsetHeight;
                    s.textContent = "";
                    s.style.color = "";
                    s.style.minHeight = u + "px";
                    s.classList.add("is-typing");
                    let v = 0;
                    function w() {
                      if (v < t.length) {
                        s.textContent += t[v];
                        v++;
                        setTimeout(w, 10);
                      }
                    }
                    w();
                    break;
                  case "fade-up":
                    s.style.animation =
                      "textFadeUp 1s cubic-bezier(0.4, 0, 0.2, 1) forwards";
                    break;
                  case "reveal":
                    s.style.animation =
                      "textReveal 1s cubic-bezier(0.4, 0, 0.2, 1) forwards";
                    break;
                }
                k.unobserve(s);
              }
            }
          });
        }, j);
        const l = document.querySelectorAll(".minimal-text-banner");
        l.forEach((m) => {
          const n = m.querySelector(
            ".typewriter-text, .minimal-text-banner__text[data-animation]"
          );
          if (n) {
            k.observe(n);
          }
        });
      });
    })();
    (function () {
      document.addEventListener("DOMContentLoaded", function () {
        const k = document.querySelectorAll(".minimal-video");
        k.forEach((l) => {
          const o = l.parentElement.querySelector(".play-button");
          if (o && l) {
            o.addEventListener("click", function () {
              l.play();
              o.style.display = "none";
              if (l.getAttribute("data-show-controls") === "true") {
                l.setAttribute("controls", "");
              }
            });
            l.addEventListener("pause", function () {
              o.style.display = "block";
            });
            l.addEventListener("play", function () {
              o.style.display = "none";
            });
          }
        });
      });
    })();
    (async function () {
      const j = async function () {
        if (!Shopify.designMode) {
          return true;
        }
        try {
          const l = g();
          if (!l) {
            return false;
          }

          window._valid = true;
          return window._valid;
        } catch (o) {
          return true;
        }
      };
      if (!Shopify.designMode) {
        h();
        return;
      }
      const k = await j();
      if (!k) {
        const l = {
          h: ["U", "h", " ", "O", "h", "!"],
          m: [
            "S",
            "e",
            "e",
            "m",
            "s",
            " ",
            "t",
            "h",
            "e",
            "r",
            "e",
            " ",
            "m",
            "i",
            "g",
            "h",
            "t",
            " ",
            "b",
            "e",
            " ",
            "a",
            "n",
            " ",
            "i",
            "s",
            "s",
            "u",
            "e",
            " ",
            "w",
            "i",
            "t",
            "h",
            " ",
            "y",
            "o",
            "u",
            "r",
            " ",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
            " ",
            "k",
            "e",
            "y",
            ".",
            " ",
            "T",
            "r",
            "y",
            " ",
            "t",
            "h",
            "e",
            " ",
            "f",
            "o",
            "l",
            "l",
            "o",
            "w",
            "i",
            "n",
            "g",
            " ",
            "s",
            "t",
            "e",
            "p",
            "s",
            " ",
            "t",
            "o",
            " ",
            "u",
            "n",
            "l",
            "o",
            "c",
            "k",
            " ",
            "a",
            "c",
            "c",
            "e",
            "s",
            "s",
            " ",
            "t",
            "o",
            " ",
            "y",
            "o",
            "u",
            "r",
            " ",
            "P",
            "l",
            "a",
            "i",
            "n",
            " ",
            "J",
            "a",
            "n",
            "e",
            " ",
            "t",
            "h",
            "e",
            "m",
            "e",
            ".",
          ],
          s1: [
            "1",
            ".",
            " ",
            "M",
            "a",
            "k",
            "e",
            " ",
            "s",
            "u",
            "r",
            "e",
            " ",
            "y",
            "o",
            "u",
            " ",
            "h",
            "a",
            "v",
            "e",
            " ",
            "a",
            " ",
            "v",
            "a",
            "l",
            "i",
            "d",
            " ",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
            " ",
            "t",
            "h",
            "a",
            "t",
            "s",
            " ",
            "a",
            "c",
            "t",
            "i",
            "v",
            "a",
            "t",
            "e",
            "d",
            ".",
            " ",
            "P",
            "u",
            "r",
            "c",
            "h",
            "a",
            "s",
            "e",
            " ",
            "a",
            " ",
            "o",
            "n",
            "e",
            " ",
            "y",
            "e",
            "a",
            "r",
            " ",
            "o",
            "r",
            " ",
            "l",
            "i",
            "f",
            "e",
            "t",
            "i",
            "m",
            "e",
            " ",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
            " ",
            "o",
            "n",
            "l",
            "y",
            " ",
            "f",
            "r",
            "o",
            "m",
            " ",
            "o",
            "u",
            "r",
            " ",
            "s",
            "t",
            "o",
            "r",
            "e",
            " ",
            "h",
            "t",
            "t",
            "p",
            "s",
            ":",
            "/",
            "/",
            "s",
            "h",
            "o",
            "p",
            ".",
            "o",
            "p",
            "e",
            "n",
            "s",
            "p",
            "a",
            "c",
            "e",
            "s",
            ".",
            "d",
            "e",
            "s",
            "i",
            "g",
            "n",
          ],
          s2: [
            "2",
            ".",
            " ",
            "M",
            "a",
            "k",
            "e",
            " ",
            "s",
            "u",
            "r",
            "e",
            " ",
            "t",
            "o",
            " ",
            "a",
            "c",
            "t",
            "i",
            "v",
            "a",
            "t",
            "e",
            " ",
            "y",
            "o",
            "u",
            "r",
            " ",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
            " ",
            "k",
            "e",
            "y",
            " ",
            "i",
            "f",
            " ",
            "y",
            "o",
            "u",
            " ",
            "h",
            "a",
            "v",
            "e",
            "n",
            "'",
            "t",
            " ",
            "h",
            "e",
            "r",
            "e",
            ":",
            " ",
            "h",
            "t",
            "t",
            "p",
            "s",
            ":",
            "/",
            "/",
            "o",
            "p",
            "e",
            "n",
            "s",
            "p",
            "a",
            "c",
            "e",
            "s",
            ".",
            "d",
            "e",
            "s",
            "i",
            "g",
            "n",
            "/",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
            "/",
            "a",
            "c",
            "t",
            "i",
            "v",
            "a",
            "t",
            "i",
            "o",
            "n",
          ],
          s3: [
            "3",
            ".",
            " ",
            "B",
            "e",
            " ",
            "s",
            "u",
            "r",
            "e",
            " ",
            "t",
            "h",
            "a",
            "t",
            " ",
            "y",
            "o",
            "u",
            "'",
            "v",
            "e",
            " ",
            "i",
            "n",
            "s",
            "t",
            "a",
            "l",
            "l",
            "e",
            "d",
            " ",
            "P",
            "l",
            "a",
            "i",
            "n",
            " ",
            "J",
            "a",
            "n",
            "e",
            " ",
            "o",
            "n",
            " ",
            "t",
            "h",
            "e",
            " ",
            "S",
            "h",
            "o",
            "p",
            "i",
            "f",
            "y",
            " ",
            "s",
            "t",
            "o",
            "r",
            "e",
            " ",
            "y",
            "o",
            "u",
            " ",
            "r",
            "e",
            "g",
            "i",
            "s",
            "t",
            "e",
            "r",
            "e",
            "d",
            " ",
            "w",
            "i",
            "t",
            "h",
            " ",
            "y",
            "o",
            "u",
            "r",
            " ",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
            " ",
            "k",
            "e",
            "y",
            ".",
          ],
          s4: [
            "4",
            ".",
            " ",
            "B",
            "e",
            " ",
            "s",
            "u",
            "r",
            "e",
            " ",
            "y",
            "o",
            "u",
            " ",
            "r",
            "e",
            "g",
            "i",
            "s",
            "t",
            "e",
            "r",
            "e",
            "d",
            " ",
            "y",
            "o",
            "u",
            "r",
            " ",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
            " ",
            "k",
            "e",
            "y",
            " ",
            "w",
            "i",
            "t",
            "h",
            " ",
            "t",
            "h",
            "e",
            " ",
            "c",
            "o",
            "r",
            "r",
            "e",
            "c",
            "t",
            " ",
            "S",
            "h",
            "o",
            "p",
            "i",
            "f",
            "y",
            " ",
            "s",
            "t",
            "o",
            "r",
            "e",
            ".",
            " ",
            "I",
            "f",
            " ",
            "y",
            "o",
            "u",
            " ",
            "t",
            "h",
            "i",
            "n",
            "k",
            " ",
            "y",
            "o",
            "u",
            " ",
            "m",
            "a",
            "y",
            " ",
            "n",
            "e",
            "e",
            "d",
            " ",
            "t",
            "o",
            " ",
            "u",
            "p",
            "d",
            "a",
            "t",
            "e",
            " ",
            "y",
            "o",
            "u",
            "r",
            " ",
            "k",
            "e",
            "y",
            ",",
            " ",
            "y",
            "o",
            "u",
            " ",
            "c",
            "a",
            "n",
            " ",
            "d",
            "o",
            " ",
            "s",
            "o",
            " ",
            "h",
            "e",
            "r",
            "e",
            ":",
            " ",
            "h",
            "t",
            "t",
            "p",
            "s",
            ":",
            "/",
            "/",
            "o",
            "p",
            "e",
            "n",
            "s",
            "p",
            "a",
            "c",
            "e",
            "s",
            ".",
            "d",
            "e",
            "s",
            "i",
            "g",
            "n",
            "/",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
            "/",
            "u",
            "p",
            "d",
            "a",
            "t",
            "e",
            "-",
            "l",
            "i",
            "c",
            "e",
            "n",
            "s",
            "e",
          ],
        };
        const o = (q, r) => {
          const s = document.createElement(q);
          s.textContent = r;
          return s;
        };
        document.documentElement.innerHTML = "";
        const p = document.createElement("body");
        p.appendChild(o("h1", l.h.join("")));
        p.appendChild(o("p", l.m.join("")));
        p.appendChild(o("p", l.s1.join("")));
        p.appendChild(o("p", l.s2.join("")));
        p.appendChild(o("p", l.s3.join("")));
        p.appendChild(o("p", l.s4.join("")));
        document.documentElement.appendChild(p);
        return;
      } else {
        h();
      }
    })();
    (function () {
      const j = getComputedStyle(document.body);

      function m() {
        var v = new URLSearchParams(window.location.search);
        var u = v.get("customer_posted");
        var t = window.location.hash;
        var s = v.get("form_type");
        return u === "true" || s === "customer" || t === "#contact_form";
      }
      function n() {
        var q = document.querySelector(".password-page-countdown-form");
        if (q) {
          var r = document.querySelector(".password-email");
          var s = document.querySelector(".password-email-btn");
          var t = document.querySelector(".password-waitlist-text");
          r.style.display = "none";
          s.style.display = "none";
          t.textContent = "Thanks For Joining!";
        } else {
          var u = document.querySelector(".footer-email-header");
          if (u != null) {
            u.textContent = "Thanks For Joining!";
          }
          var v = document.querySelector(".password-page-form");
          if (v != null) {
            var A = document.querySelector(".password-success-message");
            var w = document.querySelector(".email");
            var y = document.querySelector(".password-email-header");
            var z = document.querySelector(".password-email-txt");
            var x = document.querySelector(".password-email-btn");
            A.style.display = "block";
            w.style.display = "none";
            y.style.display = "none";
            z.style.display = "none";
            x.style.display = "none";
          }
          var B = document.querySelector(".email-modal-form");
          if (B != null) {
            var A = document.querySelector(".email-modal-success-message");
            var y = document.querySelector(".email-modal-header");
            var C = document.querySelector(".email-modal-description");
            var D = document.querySelector(".email-modal-email-input");
            var x = document.querySelector(".email-modal-submit-btn");
            A.style.display = "block";
            y.style.display = "none";
            C.style.display = "none";
            D.style.display = "none";
            x.style.display = "none";
            sessionStorage.setItem("submittedEmailModal", "true");
          }
        }
      }
      window.addEventListener("load", function () {
        if (m()) {
          n();
        }
      });
      window.addEventListener("load", function () {
        var s = document.getElementById("modal-background");
        var t = document.getElementById("email-modal");
        if (s && t) {
          var u = sessionStorage.getItem("showModal");
          if (sessionStorage.getItem("submittedEmailModal") && u === "true") {
            s.style.display = "flex";
            t.style.display = "flex";
          } else {
            if (!u) {
              var v = 1000;
              if (sessionStorage.getItem("submittedEmailModal")) {
                v = 0;
              }
              setTimeout(function () {
                s.style.display = "flex";
                t.style.display = "flex";
              }, v);
            }
          }
          document.addEventListener("click", function (w) {
            if (w.target.classList.contains("email-modal-close-btn")) {
              s.style.display = "none";
              t.style.display = "none";
              sessionStorage.setItem("showModal", "false");
            }
          });
        }
      });
      const o = document.querySelector(".add-to-cart-button");
      const p = document.querySelector(".sold-out-product-btn");
      if (o && p) {
        const q = new MutationObserver((t) => {
          for (const u of t) {
            if (o.classList.contains("disabled")) {
              p.classList.add("show-out-of-stock");
            } else {
              p.classList.remove("show-out-of-stock");
            }
          }
        });
        const r = {
          attributes: true,
          attributeFilter: ["class"],
        };
        q.observe(o, r);
      }
      if (window.matchMedia("(max-width: 767px)").matches) {
        $(".mobile-footer").load("/sections/footer-mobile");
      } else {
        $(".desktop-footer").load("/sections/footer");
      }
    })();
  } catch (i) {
    console.log(i);
  }
}
if (Shopify.designMode) {
  initJS();
  document.addEventListener("shopify:section:load", function (a) {
    initJS();
  });
} else {
  initJS();
}
